import { render, staticRenderFns } from "./Content_component.vue?vue&type=template&id=4559d010&scoped=true&"
import script from "./Content_component.vue?vue&type=script&lang=js&"
export * from "./Content_component.vue?vue&type=script&lang=js&"
import style0 from "./Content_component.vue?vue&type=style&index=0&id=4559d010&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4559d010",
  null
  
)

export default component.exports